(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}
			
			if (activeMedia?.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
					element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			if (activeMedia) {
				activeMedia.classList.add('active');
				const slider = activeMedia.closest('.product-media-modal__content_slider')?.swiper;
				if (slider) {
					slider.thumbs?.swiper?.update();
					slider.update();
					const index = Array.from(slider.slides).indexOf(activeMedia);
					if (index !== -1) {
						slider.slideTo(index, 0);
						slider.thumbs?.update(true);
					}
				} else {
					activeMedia.scrollIntoView();
				}
			}
			
			if (activeMedia?.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
				activeMedia.loadContent();
		}
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations--single');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-modal', ProductModal);
	customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
  	constructor() {
  		super();

  		const handleIntersection = (entries, observer) => {
  			if (!entries[0].isIntersecting) return;
  			observer.unobserve(this);

  			fetch(this.dataset.url)
  				.then((response) => response.text())
  				.then((text) => {
  					const html = document.createElement('div');
  					html.innerHTML = text;
  					const recommendations = html.querySelector(
  						'product-recommendations'
  					);
  					if (recommendations && recommendations.innerHTML.trim().length) {
  						this.innerHTML = recommendations.innerHTML;
  					}
  				})
  				.catch((e) => {
  					console.error(e);
  				});
  		};

  		new IntersectionObserver(handleIntersection.bind(this), {
  			rootMargin: '0px 0px 200px 0px',
  		}).observe(this);
  	}
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-bundles"] && !Shopify.designMode) return;
  try {
    
(() => {
  const visible = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { if(entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target); });
    document.querySelectorAll('.stellar-bundle-section').forEach(section => section.toggleAttribute('data-actions-visible', [...visible].some(target => section.contains(target))));
  });
  const watch = root => root.querySelectorAll('.stellar-bundle-actions').forEach(target => observer.observe(target));
  watch(document);
  document.addEventListener('shopify:section:load', event => watch(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.stellar-bundle-actions').forEach(target => { observer.unobserve(target); visible.delete(target); }));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-routine-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stellar-routine-player')) {
  customElements.define('stellar-routine-player', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.observer?.disconnect();
      this.abort = new AbortController();
      const signal = this.abort.signal, video = this.querySelector('video');
      if (!video || this.dataset.autoplay !== 'true') return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, userPaused = false, automaticPause = false;
      const pause = () => { if (!video.paused) { automaticPause = true; video.pause(); } };
      const update = () => {
        if (!visible || document.hidden || reduced.matches) { pause(); return; }
        if (!userPaused && video.paused) { video.muted = true; video.play().catch(() => {}); }
      };
      video.addEventListener('pause', () => { if (automaticPause) automaticPause = false; else userPaused = true; }, {signal});
      video.addEventListener('play', () => { userPaused = false; }, {signal});
      this.observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); }, {threshold:0.25});
      this.observer.observe(video);
      reduced.addEventListener('change', update, {signal});
      document.addEventListener('visibilitychange', update, {signal});
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.querySelector('video')?.pause(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-styling-playbook"] && !Shopify.designMode) return;
  try {
    
  const dateSelector = '.stellar-playbook__date input[type="date"]';
  function syncDateHint(input) {
    input.dataset.playbookDateEmpty = String(!input.value && !input.validity.badInput);
  }
  function syncDateHints() {
    document.querySelectorAll(dateSelector).forEach(syncDateHint);
  }
  ['input', 'change', 'focusout'].forEach(type => document.addEventListener(type, event => {
    if (event.target.matches(dateSelector)) syncDateHint(event.target);
  }));
  document.addEventListener('shopify:section:load', syncDateHints);
  window.addEventListener('pageshow', syncDateHints);
  syncDateHints();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stellar-tool-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('stellar-tool-finder')) {
  customElements.define('stellar-tool-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.anchorController = new AbortController();
      
      const update = () => {
        const goal = this.querySelector('[data-goal]:checked');
        const length = this.querySelector('[data-length]:checked');
        const isStyler = goal?.value === 'styler';
        const key = goal ? (isStyler ? (length ? 'styler-' + length.value : '') : goal.value) : '';
        const lengthField = this.querySelector('[data-length-field]');
        lengthField.hidden = !isStyler;
        lengthField.disabled = !isStyler;
        const placeholder = this.querySelector('[data-finder-placeholder]');
        placeholder.hidden = !!key;
        placeholder.textContent = isStyler ? this.dataset.lengthPrompt : this.dataset.startPrompt;
        this.querySelectorAll('[data-result]').forEach(result => { result.hidden = result.dataset.result !== key; });
      };
      this.addEventListener('change', update, { signal: this.anchorController.signal });
      update();
    }
    disconnectedCallback() {
      this.anchorController?.abort();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
